export default {
    prePayInfo: '/gateway/areaOperate/paycs/selectPrePay',
    payCreate: '/gateway/areaOperate/paycs/agentPay',
}


// WEBPACK FOOTER //
// ./src/pages/hgcPayment/api.js